import { render, staticRenderFns } from "./threaltimedata.vue?vue&type=template&id=6315f27e&scoped=true&"
import script from "./threaltimedata.vue?vue&type=script&lang=ts&"
export * from "./threaltimedata.vue?vue&type=script&lang=ts&"
import style0 from "./threaltimedata.vue?vue&type=style&index=0&id=6315f27e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6315f27e",
  null
  
)

export default component.exports